import { RegisteredComponent } from "@builder.io/sdk-react";
import { DLD_FIELD, DLT_FIELD } from "../commonFields";

export const verticalTabBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "Vertical Tab",
  image: "https://icons.veryicon.com/png/o/business/mytona/layout-tab-v.png",
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderComponents: true,
    builderLinkComponent: true,
  },
  canHaveChildren: true,
  inputs: [
    {
      name: "variant",
      type: "enum",
      enum: ["default", "multiline"],
      defaultValue: "default",
    },
    {
      name: "tabHeader",
      type: "string",
      localized: true,
      defaultValue: {
        "@type": "@builder.io/core:LocalizedValue",
        Default: "",
      },
    },
    {
      name: "tabs",
      type: "list",
      required: true,
      subFields: [
        {
          name: "label",
          type: "string",
          required: true,
          localized: true,
          defaultValue: {
            "@type": "@builder.io/core:LocalizedValue",
            Default: "Tab Label",
          },
        },
        {
          name: "head",
          type: "string",
          localized: true,
          required: false,
          helperText: "Will be shown only with multiline variant.",
        },
        {
          name: "description",
          type: "string",
          localized: true,
          required: false,
          helperText: "Will be shown only with multiline variant.",
        },
        DLT_FIELD,
        DLD_FIELD,
        {
          name: "blocks",
          type: "uiBlocks",
          localized: false,
          defaultValue: [],
        },
      ],
      defaultValue: [
        {
          label: {
            "@type": "@builder.io/core:LocalizedValue",
            Default: "Tab 1",
          },
          blocks: [
            {
              "@type": "@builder.io/sdk:Element",
              children: [
                {
                  "@type": "@builder.io/sdk:Element",
                  component: {
                    name: "Text",
                    options: {
                      text: {
                        "@type": "@builder.io/core:LocalizedValue",
                        Default: "Tab 1 Content",
                      },
                    },
                  },
                  meta: {
                    localizedTextInputs: ["text"],
                    "transformed.text": "localized",
                  },
                },
              ],
            },
          ],
        },
        {
          label: {
            "@type": "@builder.io/core:LocalizedValue",
            Default: "Tab 2",
          },
          blocks: [
            {
              "@type": "@builder.io/sdk:Element",
              children: [
                {
                  "@type": "@builder.io/sdk:Element",
                  component: {
                    name: "Text",
                    options: {
                      text: {
                        "@type": "@builder.io/core:LocalizedValue",
                        Default: "Tab 2 Content",
                      },
                    },
                  },
                  meta: {
                    localizedTextInputs: ["text"],
                    "transformed.text": "localized",
                  },
                },
              ],
            },
          ],
        },
        {
          label: {
            "@type": "@builder.io/core:LocalizedValue",
            Default: "Tab 3",
          },
          blocks: [
            {
              "@type": "@builder.io/sdk:Element",
              children: [
                {
                  "@type": "@builder.io/sdk:Element",
                  component: {
                    name: "Text",
                    options: {
                      text: {
                        "@type": "@builder.io/core:LocalizedValue",
                        Default: "Tab 3 Content",
                      },
                    },
                  },
                  meta: {
                    localizedTextInputs: ["text"],
                    "transformed.text": "localized",
                  },
                },
              ],
            },
          ],
        },
      ],
    },
    {
      name: "theme",
      type: "enum",
      helperText:
        "Due to a different theme enum structure (missing 'orange' option), the selected theme may not display correctly in the visual builder, but it will work properly on the page.",
      localized: false,
      enum: [
        {
          label: "gray",
          value: "gray",
        },
        {
          label: "black",
          value: "black",
        },
        {
          label: "white",
          value: "white",
        },
      ],
      defaultValue: "gray",
    },
    {
      name: "shownFeatures",
      friendlyName: "No. of Displayed Tab Items",
      type: "number",
      defaultValue: 4,
      localized: false,
    },
    {
      name: "nextItem",
      type: "object",
      subFields: [
        {
          name: "displayNextItemLink",
          type: "boolean",
          localized: false,
          defaultValue: false,
        },
        {
          name: "nextItemText",
          type: "string",
          localized: true,
          defaultValue: {
            "@type": "@builder.io/core:LocalizedValue",
            Default: "Next Item",
          },
        },
        DLT_FIELD,
        DLD_FIELD,
      ],
    },
    {
      name: "pagerLabel",
      type: "string",
      localized: true,
      defaultValue: {
        "@type": "@builder.io/core:LocalizedValue",
        Default: "View More Features",
      },
    },
    {
      name: "previousAnalytics",
      type: "object",
      subFields: [DLT_FIELD, DLD_FIELD],
    },
    {
      name: "nextAnalytics",
      type: "object",
      subFields: [DLT_FIELD, DLD_FIELD],
    },
    {
      name: "pagerContainerStyle",
      type: "uiStyle",
      localized: false,
      defaultValue: {},
    },
  ],
  defaultStyles: {
    width: "100%",
  },
};
